import { format } from 'date-fns';

export const UtilsService = {

  formatDateField: <T extends Record<string, any>>(data: T | T[], fieldName: string): T | T[] => {
    if (Array.isArray(data)) {
      return data.map(item => ({
        ...item,
        [fieldName]: item[fieldName] ? format(new Date(item[fieldName]), 'yyyy-MM-dd') : '',
      }));
    } else {
      return {
        ...data,
        [fieldName]: data[fieldName] ? format(new Date(data[fieldName]), 'yyyy-MM-dd') : '',
      };
    }
  },

  normalizeIsraeliPhoneNumber: (input: string): string | null => {
    if (!input) return null;

    const digits = input.replace(/\D/g, ''); // Remove all non-digit characters

    if (digits.startsWith('972')) { // Already in international format
      return digits;
    }

    if (digits.startsWith('05')) { // Convert local Israeli number to international format
      return '972' + digits.slice(1);
    }

    if (digits.startsWith('5') && digits.length === 9) { // e.g. 522441478 -> add 972 prefix
      return '972' + digits;
    }

    return null;
  },

  validatePhoneNumber: (phone: string): boolean => {

    if (!phone || phone.trim() === '') {
      return false;
    }

    const phoneRegex = /^\+?[0-9\- ]{7,20}$/; // Allow optional + at the start, digits, spaces, and dashes

    if (!phoneRegex.test(phone.trim())) {
      return false;
    }

    return true;
  },

  parseTimeToMinutes: (time: string): number => { //19:30 ==> Minutes
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  },

};
